export default __webpack_public_path__ + "static/media/sun-line.d039f63e.svg";